/**
 * Sprint 23.6 v2 — AgentDecisionsAndLearnings.
 *
 * Hero section 4: a single bottom-bordered band split into two columns —
 * Decisions (1.4fr) on the left, Learnings (1fr) on the right (per the visual
 * contract). Each column owns its own header + card list + inline empty state;
 * this wrapper only provides the section frame and the 1.4fr/1fr grid.
 *
 * v1 stacked the two as separate full-width sections — the visual-locked spec
 * pairs them side by side.
 */

import { type CSSProperties } from "react";
import { AgentDecisions } from "./AgentDecisions";
import { AgentLearningsCream } from "./AgentLearningsCream";

export interface AgentDecisionsAndLearningsProps {
  agentId: string;
  agentName: string;
  /** ISO of when the agent was created — drives the Day-0 empty states. */
  agentCreatedAt: string;
}

export function AgentDecisionsAndLearnings({
  agentId,
  agentName,
  agentCreatedAt,
}: AgentDecisionsAndLearningsProps) {
  return (
    <section style={grid}>
      <AgentDecisions
        agentId={agentId}
        agentName={agentName}
        agentCreatedAt={agentCreatedAt}
      />
      <AgentLearningsCream
        agentId={agentId}
        agentName={agentName}
        agentCreatedAt={agentCreatedAt}
      />
    </section>
  );
}

const grid: CSSProperties = {
  padding: "14px 0",
  borderBottom: "0.5px solid var(--color-border-tertiary)",
  display: "grid",
  gridTemplateColumns: "1.4fr 1fr",
  gap: 12,
  minWidth: 0,
};
